import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";
import createSavedSearchesStorage from "app/pages/sales-intelligence/sub-modules/advanced-search/services/saved-searches/storage/factory";

export default function createAdvancedSearchStorage(storageProvider: ModuleStorage) {
    const ownStorage = {};

    return Object.assign(ownStorage, createSavedSearchesStorage(storageProvider));
}
